import React, { useState, useEffect } from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { useTenant } from '../../contexts/TenantContext';
import { ReactComponent as AppIconDark } from '../../assets/brand/app_icon_dark.svg';
import { ReactComponent as AppIconLight } from '../../assets/brand/app_icon_light.svg';
import { ReactComponent as LogoDark } from '../../assets/brand/logo_dark.svg';
import { ReactComponent as LogoLight } from '../../assets/brand/logo_light.svg';

interface LogoProps {
  variant?: 'app-icon' | 'logo';
  size?: number;
  className?: string;
  isDarkMode?: boolean; // Optional override for components not using ThemeContext
}

export const Logo: React.FC<LogoProps> = ({
  variant = 'app-icon',
  size = 32,
  className = '',
  isDarkMode: isDarkModeProp
}) => {
  const theme = useTheme();
  const { tenant } = useTenant();
  const isDarkMode = isDarkModeProp ?? theme.isDarkMode;

  const [tenantImageFailed, setTenantImageFailed] = useState(false);
  // Reset the error flag when the tenant logo URL changes (admin updates).
  useEffect(() => {
    setTenantImageFailed(false);
  }, [tenant?.logo_url]);

  if (tenant?.logo_url && !tenantImageFailed) {
    return (
      <img
        src={tenant.logo_url}
        alt={tenant.name}
        width={size}
        height={size}
        className={className}
        onError={() => setTenantImageFailed(true)}
        style={{
          objectFit: 'contain',
          borderRadius: variant === 'app-icon' ? size * 0.22 : 0,
          display: 'block',
        }}
      />
    );
  }

  const LogoComponent = variant === 'app-icon'
    ? (isDarkMode ? AppIconDark : AppIconLight)
    : (isDarkMode ? LogoDark : LogoLight);

  return (
    <LogoComponent
      width={size}
      height={size}
      className={className}
      style={{
        borderRadius: variant === 'app-icon' ? size * 0.22 : 0,
        display: 'block'
      }}
    />
  );
};

export default Logo;
